import { useSfxContext } from "@/providers/SfxProvider";
import type { SfxName } from "@/lib/sfx/sfxMap";

/**
 * Beta-only sound effects hook.
 *
 * Usage:
 *   const { playSfx } = useSfx();
 *   playSfx("decision_lock");
 *
 * Plays are a no-op outside the beta scope (route + access tier), when the
 * user has muted, or before the first user gesture has unlocked audio.
 */
export function useSfx() {
  const { playSfx, muted, setMuted, inScope, unlocked } = useSfxContext();
  return { playSfx, muted, setMuted, inScope, unlocked };
}

export type { SfxName };
